import React, { useState } from "react";
import { Collapse, Form, InputGroup } from "react-bootstrap";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";

const LeftSidebar = ({themeColor}) => {
  const [openFilter, setOpenFilter] = useState(false);
  const [minPrice, setMinPrice] = useState(2500);
  const [maxPrice, setMaxPrice] = useState(7500);
  const minLimit = 0;
  const maxLimit = 10000;
  const priceGap = 1000;

  const handlePriceInputChange = (e) => {
    const { className, value } = e.target;
    const parsedValue = parseInt(value);

    if (className.includes("input-min")) {
      if (maxPrice - parsedValue >= priceGap && parsedValue >= minLimit) {
        setMinPrice(parsedValue);
      }
    } else if (className.includes("input-max")) {
      if (parsedValue - minPrice >= priceGap && parsedValue <= maxLimit) {
        setMaxPrice(parsedValue);
      }
    }
  };

  const handleRangeInputChange = (e) => {
    const { className, value } = e.target;
    const parsedValue = parseInt(value);

    if (className.includes("range-min")) {
      if (maxPrice - parsedValue >= priceGap) {
        setMinPrice(parsedValue);
      } else {
        setMinPrice(maxPrice - priceGap);
      }
    } else if (className.includes("range-max")) {
      if (parsedValue - minPrice >= priceGap) {
        setMaxPrice(parsedValue);
      } else {
        setMaxPrice(minPrice + priceGap);
      }
    }
  };
  return (
    <div className="position-sticky" style={{top: 55}}>
      <div className="pt-3">
        <h6 className="fw-bold mb-3">Price</h6>
        <div
          className="position-relative br3"
          style={{ height: 5, background: "var(--primary-light" }}
        >
          <div
            className="progress h-100 position-absolute br3 bg-color"
            style={{
              left: `${(minPrice / maxLimit) * 100}%`,
              right: `${100 - (maxPrice / maxLimit) * 100}%`,
            }}
          ></div>
        </div>
        <div className="range-input position-relative">
          <input
            type="range"
            className="range-min"
            min={minLimit}
            max={maxLimit}
            value={minPrice}
            step="100"
            onChange={handleRangeInputChange}
          />
          <input
            type="range"
            className="range-max"
            min={minLimit}
            max={maxLimit}
            value={maxPrice}
            step="100"
            onChange={handleRangeInputChange}
          />
        </div>
        <div className="w-100 hstack mt-3 gap-3 customNumberRange ">
          <InputGroup className="mb-3">
            <InputGroup.Text style={{fontSize: 12}}>MIN ($)</InputGroup.Text>
            <Form.Control
              type="number"
              value={minPrice}
              onChange={handlePriceInputChange}
            />
          </InputGroup>
          <InputGroup className="mb-3">
            <InputGroup.Text style={{fontSize: 12}}>MAX ($)</InputGroup.Text>
            <Form.Control
              type="number"
              value={maxPrice}
              onChange={handlePriceInputChange}
            />
          </InputGroup>
        </div>
      </div>
      <div className="pt-3 border-top">
        <h6 className="fw-bold mb-3">Categories</h6>
        <div className="mb-3">
          <div
            className={`hstack justify-content-between CP px-2 py-1 fw-bold ${
              openFilter === "category1" && "bg-secondary-subtle"
            } `}
            onClick={() => setOpenFilter(openFilter === "category1")}
          >
            <Form.Label className="m-0 fs-14">Category 1</Form.Label>
            {openFilter === "category1" ? (
              <IoIosArrowDropup />
            ) : (
              <IoIosArrowDropdown />
            )}
          </div>
          <Collapse in={openFilter === "category1"}>
            <div className="overflow-auto" style={{ maxHeight: 150 }}>
              <div className="hstack justify-content-between CP px-2 py-1">
                <Form.Label className="m-0">Cloth</Form.Label>
                <Form.Label className="m-0">[11]</Form.Label>
              </div>
            </div>
          </Collapse>
        </div>
        <div className="mb-3">
          <div
            className={`hstack justify-content-between CP px-2 py-1 fw-bold ${
              openFilter === "category2" && "bg-secondary-subtle"
            } `}
            onClick={() => setOpenFilter(openFilter === "category2")}
          >
            <Form.Label className="m-0 fs-14">Category 2</Form.Label>
            {openFilter === "category2" ? (
              <IoIosArrowDropup />
            ) : (
              <IoIosArrowDropdown />
            )}
          </div>
          <Collapse in={openFilter === "category2"}>
            <div className="overflow-auto" style={{ maxHeight: 150 }}>
              <div className="hstack justify-content-between CP px-2 py-1">
                <Form.Label className="m-0">Cloth</Form.Label>
                <Form.Label className="m-0">[11]</Form.Label>
              </div>
            </div>
          </Collapse>
        </div>
        <div className="mb-3">
          <div
            className={`hstack justify-content-between CP px-2 py-1 fw-bold ${
              openFilter === "category3" && "bg-secondary-subtle"
            } `}
            onClick={() => setOpenFilter(openFilter === "category3")}
          >
            <Form.Label className="m-0 fs-14">Category 3</Form.Label>
            {openFilter === "category3" ? (
              <IoIosArrowDropup />
            ) : (
              <IoIosArrowDropdown />
            )}
          </div>
          <Collapse in={openFilter === "category3"}>
            <div className="overflow-auto" style={{ maxHeight: 150 }}>
              <div className="hstack justify-content-between CP px-2 py-1">
                <Form.Label className="m-0">Cloth</Form.Label>
                <Form.Label className="m-0">[11]</Form.Label>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default LeftSidebar;
